export default __webpack_public_path__ + "static/media/0004.d4193644.svg";